import "./App.scss";
// import { Routes, Route } from "react-router-dom";
// import Layout from "./Components/Layout/Layout";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import MainContent from "./Components/MainContent/MainContent";

function App() {
  return (
    <>
      <Header></Header>
      <MainContent />
      <Footer></Footer>
    </>
  );
}

export default App;
